import { render, staticRenderFns } from "./Procedure.vue?vue&type=template&id=2c7fcf34&scoped=true"
import script from "./Procedure.vue?vue&type=script&lang=js"
export * from "./Procedure.vue?vue&type=script&lang=js"
import style0 from "./Procedure.vue?vue&type=style&index=0&id=2c7fcf34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7fcf34",
  null
  
)

export default component.exports